import React from 'react'
import { containerIds } from 'modules/ui'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { redirectTo } from 'frontend_core/dist/helpers/http'
import Path from 'routes/path'

export default class Join extends React.Component {
  constructor(props) {
    super(props)
    this.currentUser = props.data.viewer
  }

  async componentWillMount() {
    const { match, verifyInvitationFromCompany } = this.props
    const confirmationToken = match.params.token
    if (this.currentUser) {
      try {
        const res = await verifyInvitationFromCompany({
          confirmationToken,
        })

        if (res.data.verifyInvitationFromCompany.userErrors.length) {
          console.log('failed!')
        } else {
          console.log('success')
          redirectTo(wwwUrl('/'))
        }
      } catch (error) {
        console.log(error.graphQLErrors)
      } finally {
        console.log('finally')
      }
    }
  }

  render() {
    const { ui, data } = this.props
    const currentUser = data.viewer
    const { config } = this.props

    if (currentUser) {
      return null
    } else {
      return (
        <div className="site-main">
          <div className="lp-page__padding">
            <div className="page__col1">
              <div className="signup-head">
                <h1 className="page-title">{i18n.t('page.join.l_00001')}</h1>
                <ul className="signup-step signup-step2 mb20">
                  <li className="signup-step__status1 is-current">
                    {i18n.t('page.shared.l_00015')}
                  </li>
                  <li className="signup-step__status3">
                    {i18n.t('page.shared.l_00016')}
                  </li>
                </ul>
              </div>
              <p className="signup-welcome business-signup__text">
                {i18n.t('page.join.l_00002')}
                <a
                  href={Path.loginAccount(config.URL || '')}
                  className="business-link"
                >
                  {i18n.t('page.shared.l_00015')}
                </a>
                {i18n.t('page.join.l_00003')}
                <br />
                {i18n.t('page.join.l_00004')}
                <a
                  href={Path.signupAccount(config.URL || '')}
                  className="business-link"
                >
                  {i18n.t('page.shared.l_00017')}
                </a>
                {i18n.t('page.join.l_00005')}
              </p>
            </div>
          </div>
        </div>
      )
    }
  }
}
